import { useContext } from "react";
import { CreditContext, type CreditCtx } from "./CreditProvider";

export function useCredits(): CreditCtx {
  const ctx = useContext(CreditContext);
  if (!ctx) {
    throw new Error("useCredits() must be used within <CreditProvider>");
  }
  return ctx;
}


